import { Link } from "react-router-dom";
import type { User } from "@/types";

interface Props {
  seller: User & {
    soldListingsCount?: number;
    activeListingsCount?: number;
  };
}

function memberSinceLabel(iso: string): string {
  const date = new Date(iso);
  const now = new Date();
  const months =
    (now.getFullYear() - date.getFullYear()) * 12 +
    (now.getMonth() - date.getMonth());
  if (months < 1) return "narys nuo šio mėn.";
  if (months < 12) return `narys ${months} mėn.`;
  const years = Math.floor(months / 12);
  return `narys ${years} m.`;
}

export function SellerTrustBlock({ seller }: Props) {
  const sold = seller.soldListingsCount ?? 0;
  const active = seller.activeListingsCount ?? 0;
  const ratingCount = seller.ratingsCount ?? 0;
  const rating = seller.rating;

  return (
    <Link
      to={`/users/${seller.id}`}
      className="card flex flex-col gap-3 p-4 transition-colors hover:border-primary-200 hover:bg-primary-50/50"
    >
      <div className="flex items-center gap-3">
        {seller.avatarUrl ? (
          <img
            src={seller.avatarUrl}
            alt={seller.displayName}
            className="h-12 w-12 shrink-0 rounded-full object-cover"
          />
        ) : (
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-800 text-lg font-semibold text-white">
            {seller.displayName[0].toUpperCase()}
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="truncate font-semibold text-gray-900">
            {seller.displayName}
          </p>
          <p className="text-xs text-gray-500">
            {memberSinceLabel(seller.createdAt)}
          </p>
        </div>
        <svg className="h-5 w-5 shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>

      <div className="grid grid-cols-3 gap-2 border-t border-gray-100 pt-3 text-center">
        <div>
          <p className="text-base font-bold text-gray-900">
            {rating != null ? rating.toFixed(1) : "—"}
          </p>
          <p className="text-[10px] uppercase tracking-wide text-gray-500">
            {ratingCount > 0 ? `Įvertinimai (${ratingCount})` : "Be įvertinimų"}
          </p>
        </div>
        <div>
          <p className="text-base font-bold text-gray-900">{sold}</p>
          <p className="text-[10px] uppercase tracking-wide text-gray-500">Parduota</p>
        </div>
        <div>
          <p className="text-base font-bold text-gray-900">{active}</p>
          <p className="text-[10px] uppercase tracking-wide text-gray-500">Aktyvūs</p>
        </div>
      </div>
    </Link>
  );
}
